'use strict';

import { getSelectedCompanyForUser, subLangPlaceHolder } from "../jquery-functions-library";
import { addExportBtns } from "../voucher/voucher-table-export";
import {element_exists, redesignDataTablesHeader} from "../functions";

export var fnVouchersEarlierReleasesTable = function () {

    var tableName = '#datatable-vouchers-earlier-releases';

    if (!element_exists(tableName)) return;


    var form = $('#form-vouchers-earlier-releases');
    var companyId = getSelectedCompanyForUser();
    var url = '/vouchers-earlier-releases/load-table/' + companyId;
    var lang = allLangFiles.vouchers;
    var btnTextLang = allLangFiles['button-text'];

    $.fn.dataTable.moment('DD.MM.YY');
    $(tableName).css('width', '100%');

    function buildBtnContainer(btnText, dropdownItems) {
        return `
        <div class="btn-container">
              <div class="dropdown">
                <button class="btn btn-info btn-table-cell dropdown-toggle dropdownVouchersButtons" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    ${btnText}
                </button>
                <div class="dropdown-menu dropdownVoucherItems" aria-labelledby="dropdownVouchersButtons">
                    ${dropdownItems}
                </div>
            </div>            
        </div>
        `;
    }

    function getDropdownBtns(lang, voucher, btnText) {
        let dropdownItems = '';
        let count = 1;
        for (let i = 0; i < voucher.files_without_data.length; i++) {
            let text = subLangPlaceHolder(lang.attachment_number, ':number', count);
            dropdownItems += `<a class="dropdown-item" href="#" data-href="/voucher/file/${voucher.id}/attachment/${voucher.files_without_data[i].id}">${text}</a>`
            count++;
        }

        return buildBtnContainer(btnText, dropdownItems);
    }

    function getDropdownStatementBtns(lang, statement, btnText) {
        let dropdownItems = '';
        let count = 1;
        for (let i = 0; i < statement.files_without_data.length; i++) {
            let text = subLangPlaceHolder(lang.attachment_number, ':number', count);
            dropdownItems += `<a class="dropdown-item" href="#" data-href="/voucher-statements/file/${statement.id}/attachment/${statement.files_without_data[i].id}">${text}</a>`
            count++;
        }

        return buildBtnContainer(btnText, dropdownItems);
    }

    $(tableName).DataTable({
        language: allLangFiles.datatables,
        rowId: 'id',
        ajax: {
            url: url,
            type: 'POST',
            data: function (d) {
                return form.serialize();
            }
        },
        columns: [
            {
                data: 'Date',
                render: function (data, type, row) {
                    var d = new Date(row.Date);
                    return d.toLocaleDateString(undefined, {month: '2-digit', day: '2-digit', year: '2-digit'});
                },
            },
            {data: 'VoucherNumber'},
            {data: 'Text'},
            {
                data: 'Amount',
                render: function (data, type, row) {
                    return Intl.NumberFormat('da-DK').format(row.Amount);
                },
            },
            {data: 'Account'},
            {data: 'ContraAccount'},
            {data: 'department_name'},
            {data: 'comment'},
            {
                data: 'PdfUploaded',
                className: 'not-export',
                render: function (data, type, row) {
                    if (data != '') return data;
                    if (row.has_voucher) {
                        return getDropdownBtns(lang, row, lang.see);
                        return "<button class='btn btn-info btn-table-cell btn-display-earlier-voucher'>"
                            + lang.see +
                            "</button>";
                    } else if (row.has_statement) {
                        return getDropdownStatementBtns(lang, row.statement, btnTextLang['display-statement']);
                        return "<button class='btn btn-info btn-table-cell btn-display-earlier-voucher'>"
                            + btnTextLang['display-statement'] +
                            "</button>";
                    } else if (row.is_valid_no_file) {
                        return "<button class='btn btn-danger btn-table-cell' disabled>"
                            + btnTextLang['uploaded-without-voucher'] +
                            "</button>";
                    }
                    return '';
                }
            },
        ],
        order: [[0, "desc"], [1, "asc"]],
        scrollX: true,
        iDisplayLength: 100,
        lengthMenu: [[10, 25, 50, 75, 100, -1], [10, 25, 50, 75, 100, allLangFiles.datatables.all]],
    });

    redesignDataTablesHeader(tableName, false)
    //duplicates the buttons, so important that all but last button groups are hidden
    $(document).off('click', '.tab-vouchers-earlier-releases').on('click', '.tab-vouchers-earlier-releases', function(){
        addExportBtns($(tableName), 3);
    });
};